import '@angular/compiler';
import { ComponentNavComponent } from './component.nav/component.nav.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { PageChecklistComponent } from './page.checklist/page.checklist.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PageChecklistFacilitiesComponent } from './page.checklist.facilities/page.checklist.facilities.component';
import { PageInspectionComponent } from './page.inspection/page.inspection.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageInspectionViewerComponent } from './page.inspection.viewer/page.inspection.viewer.component';
import { PageMainComponent } from './page.main/page.main.component';
import { LayoutNavbarComponent } from './layout.navbar/layout.navbar.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { ComponentAuthLoginComponent } from './component.auth.login/component.auth.login.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PageProjectDetailComponent } from './page.project.detail/page.project.detail.component';
import { ComponentProjectFacilitiesComponent } from './component.project.facilities/component.project.facilities.component';
import { LayoutAuthComponent } from './layout.auth/layout.auth.component';
import { LayoutFieldComponent } from './layout.field/layout.field.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { ComponentMainOverviewComponent } from './component.main.overview/component.main.overview.component';
import { PageReleaseDiagnosticsComponent } from './page.release.diagnostics/page.release.diagnostics.component';
import { ComponentProjectDrawingAddComponent } from './component.project.drawing.add/component.project.drawing.add.component';
import { ComponentProjectFacilityAddComponent } from './component.project.facility.add/component.project.facility.add.component';
import { ComponentMainProjectAddComponent } from './component.main.project.add/component.main.project.add.component';
import { ComponentAuthRegisterComponent } from './component.auth.register/component.auth.register.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { ComponentProjectDrawingsComponent } from './component.project.drawings/component.project.drawings.component';
import { PageChecklistRespondComponent } from './page.checklist.respond/page.checklist.respond.component';
import { ComponentAuthForgotComponent } from './component.auth.forgot/component.auth.forgot.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { ComponentMainProjectsComponent } from './component.main.projects/component.main.projects.component';
import { PageProjectListComponent } from './page.project.list/page.project.list.component';
import { PageChecklistResultComponent } from './page.checklist.result/page.checklist.result.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        AppComponent,
        ComponentNavComponent,
        PortalSeasonPagenationComponent,
        PageChecklistComponent,
        PortalSeasonLoadingHexaComponent,
        PageChecklistFacilitiesComponent,
        PageInspectionComponent,
        PortalSeasonLoadingSeasonComponent,
        PageInspectionViewerComponent,
        PageMainComponent,
        LayoutNavbarComponent,
        PortalSeasonTabComponent,
        PortalSeasonLoadingComponent,
        PortalSeasonStatusbarComponent,
        ComponentAuthLoginComponent,
        PortalSeasonViewerTreeComponent,
        PageProjectDetailComponent,
        ComponentProjectFacilitiesComponent,
        LayoutAuthComponent,
        LayoutFieldComponent,
        PageHomeComponent,
        PortalSeasonUiDropdownComponent,
        ComponentMainOverviewComponent,
        PageReleaseDiagnosticsComponent,
        ComponentProjectDrawingAddComponent,
        ComponentProjectFacilityAddComponent,
        ComponentMainProjectAddComponent,
        ComponentAuthRegisterComponent,
        PortalSeasonAlertComponent,
        ComponentProjectDrawingsComponent,
        PageChecklistRespondComponent,
        ComponentAuthForgotComponent,
        PageLoginComponent,
        ComponentMainProjectsComponent,
        PageProjectListComponent,
        PageChecklistResultComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }